<template>
  <v-alert
    color="info"
    dense
    :icon="infoIcon"
    outlined
    class="core-element-info-message"
  >
    <small>{{ message }}</small>
  </v-alert>
</template>

<script>
import { INFO_ICON } from '../../../constants/app'

export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data: () => ({
    infoIcon: INFO_ICON
  })
}
</script>
